import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { CookieService } from 'ngx-cookie-service';
import { ChaptersModule } from './chapters/chapters.module';
import { MatCardModule } from '@angular/material';
import { MatButtonModule } from '@angular/material';
import { MatDialogModule } from '@angular/material';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from "@angular/material";
import { SessionService } from './shared/services/session.service';
import { SharedModule } from '../app/shared/shared.module';
import { HomeComponent } from './home/home.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { ActivationComponent } from './chapters/activation/activation.component';

//endwb
import { FKRBIndexComponent } from './fk-rb/fk-rb-index/fk-rb-index.component';
import { FKWBIndexComponent } from './fk-wb/fk-wb-index/fk-wb-index.component';
import { KeyboardToolComponent } from './shared/tools/keyboard-tool/keyboard-tool.component';
import { DrawingToolComponent } from './shared/tools/drawing-tool/drawing-tool.component';
import { LyssnapaalfabetetcapsComponent } from './fk-alphabetshelf/lyssna-pa-alfabetet-caps/lyssna-pa-alfabetet-caps.component';

//tincan
import { LyssnaEfterLjudetComponent } from './fk-tincan/lyssna-efter-ljudet/lyssna-efter-ljudet.component';
import { PdflistComponent } from './fk-tilllararen/pdfprinting/pdflist/pdflist.component';
import { Printpdflist1Component } from './fk-tilllararen/pdfprinting/printpdflist1/printpdflist1.component';
import { Printpdflist2Component } from './fk-tilllararen/pdfprinting/printpdflist2/printpdflist2.component';
import { Printpdflist3Component } from './fk-tilllararen/pdfprinting/printpdflist3/printpdflist3.component';
import { Printpdflist4Component } from './fk-tilllararen/pdfprinting/printpdflist4/printpdflist4.component';
import { Printpdflist5Component } from './fk-tilllararen/pdfprinting/printpdflist5/printpdflist5.component';
import { ExCh06Page1Component } from './fk-rb/fk-page1-exercise/ex-ch06-page1/ex-ch06-page1.component';


//Swedish Character

import { FKCharacterFComponent } from './fk-rb/fk-swedishcharacter/fk-character-f/fk-character-f.component';
import { FKCharacterNComponent } from './fk-rb/fk-swedishcharacter/fk-character-n/fk-character-n.component';



//Start StudentWeb

import { FKStudentHomeComponent } from './fk-studentweb/fk-st-studenthome/fk-st-studenthome.component';
import { FKStStorybookshelfComponent } from './fk-studentweb/fk-st-storybookshelf/fk-st-storybookshelf.component';
import { FKStLevelbookshelfAComponent } from './fk-studentweb/fk-st-levelbookshelf-a/fk-st-levelbookshelf-a.component';
import { FKStLevelbookshelfBComponent } from './fk-studentweb/fk-st-levelbookshelf-b/fk-st-levelbookshelf-b.component';
import { FKStWriteownwordComponent } from './fk-studentweb/fk-st-writeownword/fk-st-writeownword.component';
import { StorybookComponent } from './fk-rb/fk-storybook/fk-storybook.component';
import { FKStStorybookComponent } from './fk-studentweb/fk-st-storybook/fk-st-storybook.component';


@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NavMenuComponent,
    KeyboardToolComponent,
    DrawingToolComponent,
    FKRBIndexComponent,
    FKWBIndexComponent,   
    ExCh06Page1Component,
    LyssnapaalfabetetcapsComponent,
    StorybookComponent,
    FKStStorybookComponent,   
    LyssnapaalfabetetcapsComponent,    
    LyssnaEfterLjudetComponent,
    PdflistComponent,
    Printpdflist1Component,
    Printpdflist2Component,
    Printpdflist3Component,
    Printpdflist4Component,
    Printpdflist5Component,   
    FKCharacterFComponent,   
    FKCharacterNComponent,
    

    //student web    

    FKStudentHomeComponent,
    FKStStorybookshelfComponent,
    FKStLevelbookshelfAComponent,
    FKStLevelbookshelfBComponent,    
    FKStWriteownwordComponent,    
  ],
 
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ChaptersModule,
    SharedModule,
    MatCardModule,
    MatButtonModule,
    MatDialogModule,
    MatSnackBarModule,
    BrowserAnimationsModule,
    NoopAnimationsModule,

    RouterModule.forRoot([
      { path: '', component: HomeComponent },
      { path: 'home', component: HomeComponent },

      { path: 'lyssna-pa-alfabetet-caps', component: LyssnapaalfabetetcapsComponent },  
          
      { path: 'fk-rb-index', component: FKRBIndexComponent },
      { path: 'fk-wb-index', component: FKWBIndexComponent },     

      { path: 'pdfprinting/pdflist', component: PdflistComponent },
      { path: 'pdfprinting/printpdflist1', component: Printpdflist1Component },
      { path: 'pdfprinting/printpdflist2', component: Printpdflist2Component },
      { path: 'pdfprinting/printpdflist3', component: Printpdflist3Component },
      { path: 'pdfprinting/printpdflist4', component: Printpdflist4Component },
      { path: 'pdfprinting/printpdflist5', component: Printpdflist5Component },
      {
        path: 'chapter',
        children: [
          { path: 'activation', component: ActivationComponent }
        ]
      },


      // Start FK components

      { path: 'fk-st-studenthome', component: FKStudentHomeComponent },
      { path: 'fk-st-storybookshelf', component: FKStStorybookshelfComponent },
      { path: 'fk-st-levelbookshelf-a', component: FKStLevelbookshelfAComponent },
      { path: 'fk-st-levelbookshelf-b', component: FKStLevelbookshelfBComponent },
      

      { path: 'rbpagech06', loadChildren: './fk-rb/fk-rb-pgs/fk-rb-pgs-ch06/fk-rb-pgs-ch06.module#fkrbpgsch06Module', data: { preload: true } },
     
      { path: 'wbpagech06', loadChildren: './fk-wb/fk-wb-pgs/fk-wb-pgs-ch06/fk-wb-pgs-ch06.module#fkwbpgsch06Module', data: { preload: true } },
     

      //for storybook

      { path: 'fk-storybook/:id', component: StorybookComponent },
      { path: 'fk-st-storybook/:id', component: FKStStorybookComponent },


      { path: 'fkstdlevelbook', loadChildren: './fk-studentweb/fk-st-levelbook/fk-st-levelbook.module#fkstlevelbookModule', data: { preload: true } },
      { path: 'kapitelpdf', loadChildren: './fk-rb/fk-rb-kapitelpdf/fk-rb-kapitelpdf.module#fkrbkapitelpdfModule', data: { preload: true } },

    ])
  ],
 
  entryComponents:
    [
      KeyboardToolComponent,
      DrawingToolComponent,
      LyssnapaalfabetetcapsComponent,      
      LyssnaEfterLjudetComponent,     
      ExCh06Page1Component,         
      FKCharacterFComponent,    
      FKCharacterNComponent,    
      FKStWriteownwordComponent,   

    ],


  providers: [SessionService, CookieService],

      bootstrap: [AppComponent]
})
export class AppModule { }
